<div class="account-prereq-dialog">
  <h2 class="account-prereq-dialog__title">
    {{ data.title }}
  </h2>

  <p class="account-prereq-dialog__message">
    {{ data.message }}
  </p>

  <p class="account-prereq-dialog__missing">
    You still need to configure:
    <strong>{{ data.missingLabel }}</strong>
  </p>

  <div class="account-prereq-dialog__actions">
    <button
      mat-button
      color="warn"
      type="button"
      class="account-prereq-dialog__disable"
      (click)="onDisable()"
    >
      Turn off guided setup for this account
    </button>

    <button
      mat-button
      color="primary"
      type="button"
      (click)="onCancel()"
    >
      Cancel
    </button>

    <button
      mat-raised-button
      color="accent"
      type="button"
      (click)="onGo()"
    >
      {{ data.recommendedRouteLabel || "Go" }}
    </button>
  </div>
</div>


